import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, MenuProps, Space, theme } from 'antd';

import { useAppDispatch } from '@/hooks/hooks';
import { clearAuthToken } from '@/store/slices/auth/authSlice';
import { AuthUser } from '@/types';
import { Grid } from 'antd';

// const { useBreakpoint } = Grid;
const iconStyle = { fontSize: '16px' };

const { useToken } = theme;
interface ProfileDropdownProps {
  userDetail: AuthUser | null;
}

const ProfileDropdown: FC<ProfileDropdownProps> = ({ userDetail }) => {
  const { token } = useToken();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // const screen = useBreakpoint();
  // const showEmail = screen?.md ? true : false;

  const items: MenuProps['items'] = [
    {
      key: 'email',
      label: (
        <div
          style={{
            cursor: 'default',
            color: token.colorText,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            borderBottom: '1px solid #e0e0e0',
            padding: '8px 0px',
          }}
        >
          <Avatar>
            {userDetail?.name
              ? userDetail?.name?.charAt(0).toUpperCase()
              : userDetail?.email?.charAt(0).toUpperCase()}
          </Avatar>
          <span
            style={{
              fontWeight: '500',
            }}
          >
            {userDetail?.email}
          </span>
        </div>
      ),
    },
    {
      key: '1',
      label: 'Profile',
      icon: <UserOutlined style={iconStyle} />,
    },
    {
      key: '2',
      icon: <LogoutOutlined style={iconStyle} />,
      label: 'Log Out',
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '2') {
      dispatch(clearAuthToken());
      navigate('/auth');
    }
    if (e.key === '1') {
      navigate('/profile');
    }
  };

  return (
    <>
      <Dropdown
        menu={{ items, onClick: handleMenuClick }}
        trigger={['click']}
        overlayStyle={{ width: '300px' }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: token.colorText }}
        >
          <Space>
            <Avatar>
              {userDetail?.name
                ? userDetail?.name?.charAt(0).toUpperCase()
                : userDetail?.email?.charAt(0).toUpperCase()}
            </Avatar>
            {/* {showEmail && (
              <span
                style={{
                  fontWeight: '500',
                }}
              >
                {userDetail?.email}
              </span>
            )} */}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </>
  );
};

export default ProfileDropdown;
